import type { Schemas } from '../generated/laravel-typed-openapi';

/**
 * Query keys for the signed-in user's favorites.
 *
 * Keyed on the kind of thing favorited rather than on which screen asked, so every card on a page
 * shares one cache entry and one request — which is the whole reason the list read is unpaginated.
 * Nothing is keyed by user: the endpoint is scoped to the caller and the cache is cleared on sign
 * out with the rest of the query client.
 */
export const favoriteKeys = {
  all: () => ['favorites'] as const,
  lists: () => [...favoriteKeys.all(), 'list'] as const,
  list: (favoritableType: Schemas.FavoritableType) => [...favoriteKeys.lists(), favoritableType] as const,
} as const;
